<app-styleguide-specimen [rendering]="rendering" e2eId="styleguide-fieldusage-image">
  <p>Plain image</p>
  <img *scImage="rendering.fields.sample1" />

  <!--
    Advanced image usage example
    editable: controls whether image can be edited in Sitecore Experience Editor
    urlParams: parameters that are passed to Sitecore to perform server-side resizing of the image.
      IMPORTANT: urlParams must be whitelisted for resizing to occur. See /sitecore/config/*.config (search for 'allowedMediaParams')
    any other attributes: pass through to img tag
  -->
  <p>Advanced image (not editable)</p>
  <img *scImage="rendering.fields.sample2; editable: false; urlParams: scaledImageParams"
    height="50"
    width="94"
    data-sample="other-attributes-pass-through"
  />

  <!--
    Srcset adaptive image usage example
    Adaptive srcsets are supported using Sitecore server-side resizing.
    Setting `attrs.srcSet` can use Sitecore image resizing parameters (i.e. w, h, mw, mh). See the .ts file for implementation.
    IMPORTANT: srcSet params must be whitelisted for adaptive resizing to occur. See /sitecore/config/*.config (search for 'allowedMediaParams')
  -->
  <p>Srcset responsive image</p>
  <img *scImage="rendering.fields.sample2; attrs: srcSetImageAttributes"
    sizes="(min-width: 960px) 300px, 100px"
    class="img-fluid"
  />
</app-styleguide-specimen>
